import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  DigitalSubmissionSingleChoice,
  GroundTruthSingleChoice,
  QuestionSingleChoice,
} from '../../../redux/types';

type Props = {
  exerciseGroundTruth: GroundTruthSingleChoice;
  question: QuestionSingleChoice;
  submission?: DigitalSubmissionSingleChoice;
}

const RevealedAnsSingleChoice: React.FC<Props> = ({
  exerciseGroundTruth,
  question,
  submission,
}: Props) => {
  const finalAnswer = submission?.answer && exerciseGroundTruth.payload[submission.answer];
  return (
    <Box aria-label="exercise-answer-single-choice">
      {
        finalAnswer !== null && finalAnswer !== undefined && (
          <Box>
            {
              finalAnswer === 0 && (
                <Typography style={{ color: 'red', fontWeight: 500 }} component="div">Wrong Answer</Typography>
              )
            }
            {
              finalAnswer > 0 && (
                <Typography style={{ color: 'green', fontWeight: 500 }} component="div">Acceptable Answer</Typography>
              )
            }
          </Box>
        )
      }
      {
        question.payload?.map((op) => (
          <Box key={op.id} display="flex" gap={2}>
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              color="GrayText"
              maxWidth={250}
            >
              {op.text}
            </Typography>
            <Typography fontWeight={500}>{exerciseGroundTruth.payload[op.id]}</Typography>
          </Box>
        ))
      }
    </Box>
  );
};

export default RevealedAnsSingleChoice;
